// @ts-nocheck
import leadgen from './assets/leadgen.svg'
import appmagic from './assets/appmagic.svg'
import innmind from './assets/innmind.svg'

export const arrLidMagnit = [
  {
    logo: leadgen,
    alt: 'logo leadgen'
  },
  {
    logo: appmagic,
    alt: 'logo appmagic'
  },
  {
    logo: innmind,
    alt: 'logo innmind'
  }
]
